import React from 'react';

interface ERPSettingsForm {
  companyName: string;
  companyNameArabic: string;
  taxNumber: string;
  commercialRegister: string;
  companyEmail: string;
  companyPhone: string;
  companyAddress: string;
  companyWebsite: string;
}

interface CompanyTabProps {
  settings: ERPSettingsForm;
  onUpdate: (patch: Partial<ERPSettingsForm>) => void;
}

const CompanyTab: React.FC<CompanyTabProps> = ({ settings, onUpdate }) => (
  <div className="space-y-6">
    <div className="bg-blue-50 border-l-4 border-blue-500 p-4">
      <h3 className="font-semibold text-blue-900 mb-2">Company Information</h3>
      <p className="text-sm text-blue-800">Basic company details and contact information</p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Company Name (English)</label>
        <input
          type="text"
          value={settings.companyName}
          onChange={(e) => onUpdate({ companyName: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Company Name (Arabic)</label>
        <input
          type="text"
          value={settings.companyNameArabic}
          onChange={(e) => onUpdate({ companyNameArabic: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          dir="rtl"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Tax Number</label>
        <input
          type="text"
          value={settings.taxNumber}
          onChange={(e) => onUpdate({ taxNumber: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Commercial Register</label>
        <input
          type="text"
          value={settings.commercialRegister}
          onChange={(e) => onUpdate({ commercialRegister: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Company Email</label>
        <input
          type="email"
          value={settings.companyEmail}
          onChange={(e) => onUpdate({ companyEmail: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Company Phone</label>
        <input
          type="tel"
          value={settings.companyPhone}
          onChange={(e) => onUpdate({ companyPhone: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-2">Company Address</label>
        <textarea
          value={settings.companyAddress}
          onChange={(e) => onUpdate({ companyAddress: e.target.value })}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Company Website</label>
        <input
          type="url"
          value={settings.companyWebsite}
          onChange={(e) => onUpdate({ companyWebsite: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>
  </div>
);

export default CompanyTab;
